<template>
    <div class="row no-gutters" id="product-list">
        <div v-for="p in products" class="col-sm-12 col-md-4 col-lg-2 col-xl-2">
            <div class="card m-1 product-card">
				<a :href="p.order_code">
					<img class="card-img-top" :src="p.image" :alt="p.partname_en">
				</a>
                <div class="card-body">
                    <a :href="p.order_code" class="">
                        <h5 class="card-title">{{ p.partname_en }}</h5>
                        <!--<p class="card-text">{{ p.price }}</p>-->
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
        }
    },
    props: {
        products: Array
    },
}
</script>
